/**
 * External booking URL — replace this with the real RaceFacer / partner link
 * when ready. All "Book Now" / "Reserve" CTAs across the site use this.
 *
 * If the URL is relative (starts with "/"), it's used as an internal route.
 * If it's absolute (https://...), the button opens it in a new tab.
 */
export const BOOK_NOW_URL = "/contact?topic=booking";

export const isExternalBookingURL = () => /^https?:\/\//.test(BOOK_NOW_URL);
